import { render, staticRenderFns } from "./CalendarDashboard.vue?vue&type=template&id=51b4853c&scoped=true&"
import script from "./CalendarDashboard.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CalendarDashboard.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b4853c",
  null
  
)

export default component.exports